export class Organization {
    crmId?: string;
    healthCareDataEnabled?: boolean;
    id: string;
    name: string;
    mfaEnabled: boolean;
    ssoEnabled: boolean;
    virtualAgentsEnabled: boolean;

    constructor(restOrganization: any) {
        this.crmId = restOrganization?.CrmId;
        this.healthCareDataEnabled = restOrganization?.HealthCareDataEnabled;
        this.id = restOrganization?.Id;
        this.mfaEnabled = restOrganization.MfaEnabled || false;
        this.name = restOrganization.Name || "";
        this.ssoEnabled = restOrganization.SsoEnabled || false;
        this.virtualAgentsEnabled = restOrganization.VirtualAgentsEnabled || false;
    }
}
